import React from 'react';
import {
  StyledGallery,
  ImageWrapper,
  CroppedImage,
  StyledGalleryWide,
  WideGalleryImage,
} from './Hikes.styles';

type PhotoGalleryProps = {
  images: string[];
  wide?: boolean;
};

export const PhotoGallery = ({ images, wide = false }: PhotoGalleryProps) => {
  if (images.length === 0) return null;

  if (wide) {
    return (
      <StyledGalleryWide>
        {images.map((src) => (
          <WideGalleryImage key={src} src={src} alt="" />
        ))}
      </StyledGalleryWide>
    );
  }

  return (
    <StyledGallery>
      {images.map((src) => (
        <ImageWrapper key={src}>
          <CroppedImage src={src} alt="" />
        </ImageWrapper>
      ))}
    </StyledGallery>
  );
};

export default PhotoGallery;
